import type CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import type RichText from '@src/quince-site-common/src/domains/RichText'
import type { ProductListTwoSectionConfig } from '@src/SectionRenderer/sections/productListTwo/ProductListTwo'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

// Flatten a Contentful rich-text document to its plain text (concatenate every text node).
export const collectRichTextValue = (node: unknown): string => {
  if (!node || typeof node !== 'object') return ''
  const { value, content } = node as { value?: unknown; content?: unknown }
  const own = typeof value === 'string' ? value : ''
  const children = Array.isArray(content) ? content.map(collectRichTextValue).join('') : ''
  return own + children
}

export const richTextToPlainText = (richText?: RichText): string => collectRichTextValue(richText?.raw).trim()

export const matchProductListTitleToSearch = (section: CustomSection): CustomSection => {
  if (!shouldUseDesignSystem()) return section

  const [titleRichText, ...remainingRichTexts] = section.richTexts ?? []
  const headingText = richTextToPlainText(titleRichText)

  const alreadyHasStringHeading = Boolean((section as ProductListTwoSectionConfig).heading)
  if (section.sectionType !== CUSTOM_SECTION_TYPE.PRODUCT_LIST_TWO || alreadyHasStringHeading || !headingText) {
    return section
  }
  const patched: ProductListTwoSectionConfig = {
    ...section,
    heading: headingText,
    headingFont: 'ivy',
    richTexts: remainingRichTexts,
  }
  return patched
}
